export const loaScheduleAction = (state = {}, action) => {
  switch (action.type) {
    case "LOAN_SCEDULE_ACTION":
      return action.data;

    default:
      return state;
  }
};
